export default __webpack_public_path__ + "static/media/glass_still_life.03003490.jpg";